import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/userActions';
// import { useAuth0 } from '../react-auth0-spa';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
  IonContent,
  IonItem,
  IonLabel,
  IonChip,
  IonLoading,
  IonItemDivider,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
} from '@ionic/react';
import { Line } from 'react-chartjs-2';

import TopSellingItemsContainer from './TopSellingItemsContainer';

const Dashboard: React.FC = (props: any) => {
  const { userDBInfo, userChartInfo, userSweepInfo } = props;

  const [chartInfo, setChartInfo] = useState<any>('');
  const [labels, setLabels] = useState<any>('');
  const [values, setValues] = useState<any>('');

  try {
    useEffect(() => {
      setChartInfo(userChartInfo);
      setLabels(userChartInfo.map((data: any) => data.month));
      setValues(userChartInfo.map((data: any) => data.total));
    }, [chartInfo, userChartInfo]);
  } catch (e) {
    console.log('loaded on user edit');
    window.location.reload();
  }

  if (userDBInfo === null) {
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  const state = {
    labels: labels.slice(-6),
    datasets: [
      {
        label: 'Sale',
        fill: false,
        lineTension: 0.5,
        backgroundColor: 'rgba(76,141,255,1)',
        borderColor: 'rgba(76,141,255,1)',
        borderWidth: 2,
        data: values.slice(-6),
      },
    ],
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>Dashboard</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid class="ion-margin-top">
          <IonRow>
            <IonCol>
              <IonLabel class="ion-text-center">
                <h1>KES {userDBInfo?.balance?.toFixed(2) || '0.00'}</h1>
                <h3>Total Balance</h3>
              </IonLabel>
            </IonCol>
            <IonCol>
              <IonLabel class="ion-text-center">
                <h1>
                  KES {userDBInfo?.availableBalance?.toFixed(2) || '0.00'}
                </h1>
                <h3>Available Balance</h3>
              </IonLabel>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonLabel class="ion-text-center">
          <h3 style={{ marginTop: '2.5vh' }}> Sales for last 180 days</h3>
        </IonLabel>

        <Line
          data={state}
          options={{
            title: {
              display: false,
              text: 'Sales for last 180 days',
              fontSize: 20,
            },
            legend: {
              display: false,
              position: 'right',
            },
            scales: {
              xAxes: [
                {
                  gridLines: {
                    //color: "rgba(0, 0, 0, 0)",
                  },
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    //color: "rgba(0, 0, 0, 0)",
                  },
                  scaleLabel: {
                    display: false,
                    labelString: 'KES',
                  },
                },
              ],
            },
          }}
        />
        <TopSellingItemsContainer />


        {userDBInfo.number && (
            <IonButton color="primary" 
            expand="block"
            disabled={!userDBInfo.number}
            routerLink="/sweep">
            Sweep Balance
            </IonButton>
        )}

        {userSweepInfo ? (
          <IonItem class="ion-padding-bottom">
            <IonLabel>
              <h1>
                <b>
                  <p>Last Sweep Request</p>
                </b>
              </h1>
              <h4>
                <b>
                  <p>KES {userSweepInfo.amount}</p>
                </b>
              </h4>
              <p>{userSweepInfo.createdAt}</p>
            </IonLabel>
          </IonItem>
        ) : null}
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.userReducer.user,
    userDBInfo: state.userReducer.userDbInfo,
    userChartInfo: state.userReducer.userChartInfo,
    userSweepInfo: state.userReducer.userSweepInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onUpdateUser: (payload: {}) => dispatch(actionCreator.updateUser(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
